import { getPageVisibilityState } from '../../hidden-timing';
import { withProfiling } from '../../self-measurements';
var getPageVisibilityUpToTTAI = withProfiling(function getPageVisibilityUpToTTAI(interaction) {
  var start = interaction.start,
    end = interaction.end;
  return getPageVisibilityState(start, end);
});
export default getPageVisibilityUpToTTAI;